import { combineReducers, createStore, compose, applyMiddleware } from "redux";
import createSagaMiddleware from "@redux-saga/core";
import rootSaga from "../sagas";
import { apiRoutes, permissions } from "../reducers/apiRoutes.reducer";
import { loadingReducer } from "../reducers/loading.reducer";
import { subAppsConfig } from "../reducers/subAppsConfig.reducer";
import { SubAppConfig } from "../reducers/subAppsConfig.reducer";
import { activeSubApps } from "../reducers/activeSubApps.reducer";
import { initialized } from "../reducers/initialized.reducer";
import { Route } from "../api/apiTypes";

export interface SkeletonState {
    initialized: boolean;
    loading: boolean;
    apiRoutes: any[];
    subAppsConfig: { [key: string]: SubAppConfig };
    activeSubApps: SubAppConfig[];
}

const skeletonReducer = combineReducers({
    loadingReducer,
    apiRoutes,
    subAppsConfig,
    activeSubApps,
    initialized,
    permissions
});

export const logger = store => next => action => {
    let result = next(action);
    console.log(
        action.type,
        "\n",
        "|-- Payload:\t\t",
        action.payload,
        "\n",
        "|-- Next state:\t",
        store.getState(),
        "\n *"
    );
    return result;
};

export const crashReporter = store => next => action => {
    try {
        return next(action);
    } catch (err) {
        console.error("Caught an exception!", err);
        throw err;
    }
};

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "Skeleton Store"
      })
    : compose;

export const skeletonStore = createStore(
    skeletonReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const skeletonStoreSelectors = {
    apiRoutes: (state = skeletonStore.getState()) =>
        state.apiRoutes.reduce((accumulator, currentValue) => {
            return { ...accumulator, [currentValue.name]: currentValue };
        }, {}),
    loading: (state = skeletonStore.getState()) => state.loadingReducer,
    subAppsConfig: (state = skeletonStore.getState()) => state.subAppsConfig,
    activeSubApps: (state = skeletonStore.getState()) => state.activeSubApps,
    initialized: (state = skeletonStore.getState()) => state.initialized,
    permissions: (state = skeletonStore.getState()) => state.permissions,
    reducedRoutes: (state = skeletonStore.getState()) => {
        const routes: string[] = state.apiRoutes.reduce(
            (accumulator, route) => {
                if (
                    route.extra &&
                    route.extra.service &&
                    accumulator.indexOf(route.extra.service) === -1
                ) {
                    accumulator.push(route.extra.service);
                }

                return accumulator;
            },
            []
        );
        return routes;
    }
};

sagaMiddleware.run(rootSaga);
